import { render, staticRenderFns } from "./TextareaControl.vue?vue&type=template&id=90b215e0&scoped=true&"
import script from "./TextareaControl.vue?vue&type=script&lang=js&"
export * from "./TextareaControl.vue?vue&type=script&lang=js&"
import style0 from "./TextareaControl.vue?vue&type=style&index=0&id=90b215e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b215e0",
  null
  
)

export default component.exports